import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, inject, PLATFORM_ID, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { Work } from './Work';
import { CommonModule } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';
import { DisableOnMobileDirective } from '../../directives/disable-on-mobile.directive';
import { StarsBackgroundComponent } from '../stars-background/stars-background.component';
import { Device } from '../../app.component';

@Component({
  selector: 'app-works',
  imports: [CommonModule, DisableOnMobileDirective, StarsBackgroundComponent],
  templateUrl: './works.component.html',
  styleUrl: './works.component.less'
})
export class WorksComponent implements AfterViewInit {
  @ViewChildren('work_card') workCards!: QueryList<ElementRef>;
  @ViewChild('work_popup') work_popup!: ElementRef;
  @ViewChild('starCanvas') stars_background!: StarsBackgroundComponent;

  private elRef = inject(ElementRef);
  private renderer = inject(Renderer2);
  private cdr = inject(ChangeDetectorRef);
  private platformId = inject(PLATFORM_ID);

  device: string = Device.Desktop;
  Device = Device;

  works: Work[] = [];
  selectedWork: Work | null = null;

  showImages: boolean = false;
  showPopup: boolean = false;

  constructor() {
    this.initializeWorks();
  }

  private initializeWorks() {

    const anaPellonWork = new Work("Ana - Psicóloga Sanitaria", $localize`Desarrollo de la página web para una psicóloga, creada con Angular 20 y optimizada para alcanzar una puntuación de 100/100 en Google Lighthouse. El proyecto, aún en evolución, se centra en ofrecer una experiencia clara y accesible para los usuarios mientras se trabaja de forma continua en mejorar su posicionamiento en buscadores. El objetivo principal es construir una plataforma ligera, rápida y preparada para crecer con nuevas funcionalidades y contenidos.`, "https://anapellonpsicologa.com/");
    anaPellonWork.addImage("assets/images/ana_pellon_psicologa.webp", 1920, 1080);
    anaPellonWork.addPreviewImage("assets/images/ana_pellon_psicologa_preview.webp", 600, 304);
    anaPellonWork.addPreviewMobileImage("assets/images/ana_pellon_psicologa_preview_mobile.webp", 500, 254);
    this.works.push(anaPellonWork);

    const visualSariakWork = new Work("Visual Sariak", $localize`Plataforma web end-to-end desarrollada para gestionar el concurso de escaparates de la Cámara de Comercio de Álava. Como responsable técnico único, diseñé la arquitectura utilizando Angular 18 y un backend ligero en Express.js. El sistema centraliza la gestión integral del concurso mediante un panel administrativo robusto y ofrece una experiencia de usuario fluida en el portal público.`, "https://premiosvisualsariak.eus/");
    visualSariakWork.addImage("assets/images/visual_sariak.webp", 1920, 1080);
    visualSariakWork.addPreviewImage("assets/images/visual_sariak_preview.webp", 600, 304);
    visualSariakWork.addPreviewMobileImage("assets/images/visual_sariak_preview_mobile.webp", 500, 254);
    this.works.push(visualSariakWork);

    const advanceWork = new Work("Advance Affinity", $localize`Desarrollo del portal corporativo en colaboración directa con Accenture. Lideré la implementación técnica sobre Oracle Content Manager, abarcando desde la personalización avanzada de plantillas hasta la optimización crítica del rendimiento frontend. El resultado fue una integración fluida de contenidos y diseño, garantizando una experiencia de usuario alineada con los altos estándares de la marca.`, "https://www.advance-affinity.com")
    advanceWork.addImage("assets/images/advance.webp", 1920, 1080);
    advanceWork.addPreviewImage("assets/images/advance_preview.webp", 600, 304);
    advanceWork.addPreviewMobileImage("assets/images/advance_preview_mobile.webp", 500, 254);
    this.works.push(advanceWork);

    const galloWork = new Work("Pastas Gallo", $localize`Optimización técnica y evolución del sitio corporativo basado en WordPress. Mi intervención se centró en mejorar drásticamente los tiempos de carga (WPO) y la adaptabilidad móvil. Además, desarrollé funcionalidades a medida para el catálogo de productos y resolví deuda técnica, asegurando la estabilidad y escalabilidad de la plataforma digital de la marca.`, "https://www.pastasgallo.es");
    galloWork.addImage("assets/images/gallo.webp", 1920, 1080);
    galloWork.addPreviewImage("assets/images/gallo_preview.webp", 600, 304);
    galloWork.addPreviewMobileImage("assets/images/gallo_preview_mobile.webp", 500, 254);
    this.works.push(galloWork);

    const fgcWork = new Work("FGC Android", $localize`Aplicación Android nativa diseñada para facilitar la movilidad de miles de usuarios. Desarrollé la integración de datos en tiempo real para horarios e incidencias ferroviarias, optimizando la arquitectura de comunicación para garantizar una respuesta inmediata. Implementé funcionalidades clave como alertas personalizadas y gestión de favoritos, mejorando significativamente la usabilidad del servicio.`, "https://play.google.com/store/apps/details?id=com.iboomobile.fgc&hl=es")
    fgcWork.addImage("assets/images/fgc.webp", 478, 307);
    fgcWork.addPreviewImage("assets/images/fgc.webp", 478, 307);
    fgcWork.addPreviewMobileImage("assets/images/fgc_mobile.webp", 478, 307);
    this.works.push(fgcWork);

    const lillaWork = new Work("L'illa Android", $localize`Optimización de la App nativa de L'illa Diagonal. El principal desafío técnico fue la integración de un módulo externo de Realidad Aumentada (Unity) dentro de la arquitectura Android para una campaña de gamificación. Logré resolver la compleja interoperabilidad entre la app nativa y el motor Unity, permitiendo una transición fluida para que los usuarios pudieran escanear marcadores y acceder a los premios.`, "https://play.google.com/store/apps/details?id=com.mubiquo.lilla&hl=en&gl=US");
    lillaWork.addImage("assets/images/illa.webp", 478, 307);
    lillaWork.addPreviewImage("assets/images/illa.webp", 478, 307);
    lillaWork.addPreviewMobileImage("assets/images/illa_mobile.webp", 478, 307);
    this.works.push(lillaWork);

    this.selectedWork = null;
  }

  ngAfterViewInit(): void {
    this.resetWorkCards();
    this.onResize();
  }

  private resetWorkCards(): void {
    this.workCards.forEach((cardRef: ElementRef) => {
      const fakeEvent = {
        clientX: 0,
        clientY: 0
      } as MouseEvent;

      this.onMouseMove(fakeEvent, cardRef.nativeElement);
      this.onMouseLeave(cardRef.nativeElement);
    });
  }

  clickCard(id: number) {
    const workCard = this.elRef.nativeElement.querySelector('#work_' + id);
    if (workCard.getAttribute('disabled') !== 'true') {
      this.selectedWork = this.works[id];
      this.openWork();
    } else {
      window.open(this.works[id].url, "_blank");
    }
  }

  private openWork(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.showPopup === false) {
        this.showPopup = true;

        this.cdr.detectChanges();

        setTimeout(() => {
          const miDiv = this.elRef.nativeElement.querySelector('#work_popup');
          const img = this.elRef.nativeElement.querySelector('#work_popup img');

          this.renderer.addClass(miDiv, 'open');

          setTimeout(() => {
            this.stars_background.redrawCanvas();
          }, 1);

          setTimeout(() => {
            this.renderer.addClass(img, 'show');
          }, 100);

          this.scrollToView();
        }, 1);
      }
    }
  }

  closeSelected() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.showPopup === true) {
        this.showPopup = false;
        const miDiv = this.elRef.nativeElement.querySelector('#work_popup');
        const img = this.elRef.nativeElement.querySelector('#work_popup img');
        this.renderer.removeClass(miDiv, 'open');
        this.renderer.removeClass(img, 'show');
        this.selectedWork = null;
      }
    }
  }

  private scrollToView() {
    const element = this.work_popup.nativeElement;
    const offset = 40;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;

    setTimeout(() => {
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }, 100);
  }

  onMouseMove(event: MouseEvent, element: HTMLElement) {
    if (isPlatformBrowser(this.platformId)) {
      const { clientX, clientY } = event;
      const { left, top, width, height } = element.getBoundingClientRect();
      const offsetX = (clientX - left) / width - 0.5;
      const offsetY = (clientY - top) / height - 0.5;

      const rotationY = -offsetX * 40;
      const rotationX = offsetY * 40;
      const shadowX = rotationY;
      const shadowY = -rotationX;

      this.renderer.addClass(element, 'transformado');
      this.renderer.setStyle(element, 'transform', `rotateY(${rotationY}deg) rotateX(${rotationX}deg)`);
      this.renderer.setStyle(element, 'boxShadow', `${shadowX}px ${shadowY}px 5px 0px #e8ecefa4`);
    }
  }

  onMouseLeave(element: HTMLElement) {
    this.renderer.removeClass(element, 'transformado');
    this.renderer.removeStyle(element, 'transform');
    this.renderer.removeStyle(element, 'boxShadow');
  }

  @HostListener('window:resize')
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      const screenWidth = window.innerWidth;
      const newDevice = screenWidth > 815 ? Device.Desktop : Device.Mobile;

      if (this.device !== newDevice) {
        this.device = newDevice;
        this.cdr.detectChanges();
      }
    }
  }

  @HostListener("window:scroll")
  onScroll() {
    if (isPlatformBrowser(this.platformId) && this.showImages === false) {
      const worksSection = document.getElementById('works');
      if (!worksSection) return;

      const { top, bottom } = worksSection.getBoundingClientRect();
      if (top <= window.innerHeight && bottom >= 0) {
        this.showImages = true;
      }
    }
  }

}
